import React, { useState } from 'react';
import { deleteRecord } from '../utils/deleteRecord';
import './DeleteButton.css';

// A Delete button with an in-page confirmation. It deliberately avoids
// window.confirm/alert: Safari (especially a home-screen app) can suppress those,
// which made Delete look dead on a phone.
function DeleteButton({ url, noun, warning, onDeleted, className, children = 'Delete' }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const close = () => {
    setOpen(false);
    setError('');
  };

  const confirm = async () => {
    setBusy(true);
    setError('');
    const result = await deleteRecord(url);
    setBusy(false);
    if (result.ok) {
      setOpen(false);
      onDeleted();
    } else {
      setError(result.message);
    }
  };

  return (
    <>
      <button type="button" className={className} onClick={() => setOpen(true)}>
        {children}
      </button>
      {open && (
        <div className="confirm-overlay" role="dialog" aria-modal="true">
          <div className="confirm-box">
            <p className="confirm-message">
              Delete this {noun}{warning ? ` ${warning}` : ''}?
            </p>
            {error && <p className="confirm-error">{error}</p>}
            <div className="confirm-actions">
              <button type="button" className="btn btn-secondary" onClick={close} disabled={busy}>
                Cancel
              </button>
              <button type="button" className="btn btn-danger" onClick={confirm} disabled={busy}>
                {busy ? 'Deleting...' : 'Delete'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DeleteButton;
